import React from "react";
import { Tag } from "antd";
import { SecurePassLogType, SecurePassLogTypeIcon, SecurePassLogTypeMap } from "@/utils/enum";

const SecurePassLogTypeTag = ({ logType, isSuccess }) => {
  if (!logType) return null;

  const label = SecurePassLogTypeMap[logType];
  const icon = SecurePassLogTypeIcon[logType];

  const isInfoLog = [
    SecurePassLogType.QRScanned,
    SecurePassLogType.SecurePassSend,
    SecurePassLogType.QRCodeRetrieved,
  ].includes(logType);

  const getTagColor = () => {
    if (isInfoLog) return "processing";
    if (isSuccess) return "success";
    return "error";
  };

  const color = getTagColor();

  return (
    <Tag color={color} icon={icon}>
      {label}
    </Tag>
  );
};

export default SecurePassLogTypeTag;
